import { api } from '@/shared/lib/api'
import type {
  ClientBenefitsResponse,
  ClientBenefitHistoryItem,
  ClientBenefit,
  AvailableBenefitsResponse,
} from '../types'
import type { PaginatedResponse } from '@/shared/types'

export const clientBenefitsService = {
  getActive: async (clientId: number): Promise<ClientBenefitsResponse> => {
    const { data } = await api.get(`/client_benefits/${clientId}`)
    return data
  },

  getAll: async (clientId: number): Promise<ClientBenefitHistoryItem[]> => {
    const { data } = await api.get(`/client_benefits/${clientId}/all`)
    return data
  },

  getHistory: async (
    clientId: number,
    page: number,
    limit: number,
  ): Promise<PaginatedResponse<ClientBenefit>> => {
    const { data } = await api.get(`/client_benefits/${clientId}/history`, {
      params: { page, limit },
    })
    return data
  },

  getAvailable: async (category?: string): Promise<AvailableBenefitsResponse> => {
    const params: Record<string, string> = {}
    if (category) params.category = category
    const { data } = await api.get('/available_benefits/', { params })
    return data
  },
}
